import styled from 'styled-components'
import { Layout } from 'antd'

import { Image } from 'src/components/Ant'
import images from 'src/config/images'

const Container = styled(Layout)`
  align-items: center;
  background-color: #f0f2f5;
  background-image: url(${images.login.bg});
  background-position: center 110px;
  background-repeat: no-repeat;
  background-size: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  overflow: auto;
`

const InitialLogo = styled(Image)`
  width: 400px;
`

export { Container, InitialLogo }
